import styles from "./BrandMark.module.css";

/** The app mark: a flacon outline. Decorative; the product name always sits next to it. */
export function BrandMark() {
  return (
    <svg className={styles.mark} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        className={styles.outline}
        d="M10 3h4v3h-4zM9 6h6l1 2H8zM6.5 8h11a1.5 1.5 0 0 1 1.5 1.5v9A2.5 2.5 0 0 1 16.5 21h-9A2.5 2.5 0 0 1 5 18.5v-9A1.5 1.5 0 0 1 6.5 8z"
      />
      <path className={styles.liquid} d="M7 14.5c2-1 3.5 1 5 0s3-1 5 0V18a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z" />
    </svg>
  );
}
